<mat-icon class="{{classColor}}" [style]="'font-size: '+size+'; width: '+size+';height: '+size+';'">{{icon}}</mat-icon>
